import { useEffect, useState } from 'react'
import {
    getAllBackofficePuntoVentas,
    getAllBackofficeSucursales,
} from '../../../Services/backofficeService'

/**
 * Sucursales y puntos de venta del tenant (backoffice). Los datos fiscales para PV se cargan en AddPuntoVenta con getAllBackofficeDatoFiscales.
 */
const useBackofficeListsForTenant = (tenantId) => {
    const [sucursales, setSucursales] = useState([])
    const [puntoVentas, setPuntoVentas] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!tenantId) {
            setSucursales([])
            setPuntoVentas([])
            setLoading(false)
            return
        }

        let cancelled = false
        setLoading(true)

        Promise.all([
            getAllBackofficeSucursales(tenantId, true, 0, '', 500),
            getAllBackofficePuntoVentas(tenantId, null, true, 0, '', 500),
        ])
            .then(([sRes, pvRes]) => {
                if (cancelled) return
                setSucursales(sRes.data.content || [])
                setPuntoVentas(pvRes.data.content || [])
            })
            .catch(() => {
                if (!cancelled) {
                    setSucursales([])
                    setPuntoVentas([])
                }
            })
            .finally(() => {
                if (!cancelled) setLoading(false)
            })

        return () => {
            cancelled = true
        }
    }, [tenantId])

    return { sucursales, puntoVentas, loading }
}

export default useBackofficeListsForTenant
